var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7491B7A-4F8B-41C9-9D54-267C4897EF23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Details---M---1",
    transform: "translate(-138.000000, -290.000000)",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188,390 C215.620968,390 238,367.620968 238,340 C238,312.379032 215.620968,290 188,290 C160.379032,290 138,312.379032 138,340 C138,367.620968 160.379032,390 188,390 Z M188,344.83871 C178.201692,344.83871 170.258065,336.895083 170.258065,327.096774 C170.258065,317.298466 178.201692,309.354839 188,309.354839 C197.798308,309.354839 205.741935,317.298466 205.741935,327.096774 C205.741935,336.895083 197.798308,344.83871 188,344.83871 Z M188,378.709677 C176.165283,378.709677 165.560523,373.346853 158.46371,364.959638 C162.253993,357.822659 169.673308,352.903226 178.322581,352.903226 C178.80653,352.903226 179.290283,352.98395 179.753954,353.124921 C182.374921,353.971735 185.116975,354.516129 188,354.516129 C190.883025,354.516129 193.645161,353.971735 196.246046,353.124921 C196.709717,352.98395 197.19347,352.903226 197.677419,352.903226 C206.326692,352.903226 213.746007,357.822659 217.53629,364.959638 C210.439477,373.346853 199.834717,378.709677 188,378.709677 Z",
    id: "u"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.fa2bc10ac137cf9ec5e281f326fe44f6.svg";
export { ForwardRef as ReactComponent };